import { SubmissionPlacementTaskInfo } from '@common/types';
import { CapitolaClient } from './base';

export class SubmissionPlacementTaskClient extends CapitolaClient<SubmissionPlacementTaskInfo> {
  public get resourceName(): string {
    return 'submission-placement-task';
  }
}
